<template>
  <div class="yh-page">
    <el-card class="py-4 px-5" v-loading="loading || saving" :element-loading-text="savingText">
      <el-form :rules="rules" ref="dataForm" :model="fd" label-position="right" label-width="120px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="船名" prop="name">
              <el-input v-model="fd.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="曾用名" prop="former_name">
              <el-select v-model="fd.former_name" filterable
                         placeholder="选择船舶" @change="handleSelectShip">
                <el-option v-for="ship in ship_list" :key="ship.id" :label="ship.name"
                           :value="ship.id">
                </el-option>
              </el-select>
              <!--<el-input v-model="fd.former_name"></el-input>-->
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="船舶识别号" prop="id_code">
              <el-input v-model="fd.id_code"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="船检登记号" prop="inspection_reg_num">
              <el-input v-model="fd.inspection_reg_num"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="航区" prop="airworthiness_area">
              <el-select class="filter-item" v-model="fd.airworthiness_area" filterable
                         placeholder="请选择适合区域" style="width: 100%;">
                <el-option v-for="(area, index) in airworthiness_area_list" :key="index" :label="area.value"
                           :value="area.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="船籍港" prop="reg_port">
              <el-input v-model="fd.reg_port"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="总吨位" prop="gross_tonnage">
              <el-input type="Number" v-model="fd.gross_tonnage"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="净吨位" prop="net_tonnage">
              <el-input type="Number" v-model="fd.net_tonnage"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="border-top py-3"><h5 class="text-center">船舶主要项目</h5></el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="船舶类型" prop="type">
              <el-select class="w-100" v-model="fd.type" filterable placeholder="请选择船舶类型">
                <el-option v-for="(type, index) in type_list" :key="index" :label="type.value" :value="type.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="建造完工日期" prop="construct_date">
              <el-date-picker v-model="fd.construct_date"
                              type="date" value-format="yyyy-MM-dd"
                              placeholder="请选择建造完工日期" class="w-100"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="改建日期" prop="reconstruct_date">
              <el-date-picker v-model="fd.reconstruct_date"
                              type="date" value-format="yyyy-MM-dd"
                              placeholder="请选择改建日期" class="w-100"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <!--<el-row>
          <el-col :span="24">
            <el-form-item label="船舶建造地点" prop="construct_place">
              <el-input v-model="fd.construct_place"></el-input>
            </el-form-item>
          </el-col>
        </el-row>-->
        <el-row>
          <el-col :span="12">
            <el-form-item label="船舶制造厂" prop="construct_plant">
              <el-input v-model="fd.construct_plant"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="船舶改建厂" prop="reconstruct_plant">
              <el-input v-model="fd.reconstruct_plant"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="船舶所有人" prop="owner">
              <el-select class="w-100" v-model="fd.owner" filterable multiple
                         placeholder="请选择船舶所有人">
                <el-option v-for="customer in customer_list" :key="customer.id" :label="customer.name"
                           :value="customer.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="text-center py-2"><h5>船体部分</h5></el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="总长" prop="total_length">
              <el-input type="Number" v-model="fd.total_length"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="船宽" prop="total_width">
              <el-input type="Number" v-model="fd.total_width"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="型深" prop="depth">
              <el-input type="Number" v-model="fd.depth"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="空载排水量" prop="light_displacement">
              <el-input type="Number" v-model="fd.light_displacement"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="船体材料" prop="hull_material">
              <!--el-input v-model="fd.hull_material"></el-input -->
              <el-select v-model="fd.hull_material" class="w-100">
                <el-option v-for="item in hull_material_list" :key="item.code" :label="item.value"
                           :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="载重吨位" prop="load_tonnage">
              <el-input type="Number" v-model="fd.load_tonnage"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="最低配员人数" prop="crew_num">
              <el-input type="Number" v-model="fd.crew_num"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="text-center py-2"><h5>轮机部分</h5></el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="主机型号" prop="host_model">
              <el-input v-model="fd.host_model"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="主机类型" prop="host_type">
              <el-input v-model="fd.host_type"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="主机台数" prop="host_number">
              <el-input type="Number" v-model="fd.host_number"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="船舶功率" prop="power">
              <el-input type="Number" v-model="fd.power"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="text-center py-2"><h5>其他</h5></el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="是否港澳航线" prop="hk_route">
              <el-switch v-model="fd.hk_route"
                         active-text="是"
                         inactive-text="否"
                         :active-value="1"
                         :inactive-value="0">
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="航行范围" prop="sailing_range">
              <el-input v-model="fd.sailing_range"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="经营方式" prop="operation_mode">
              <el-select class="w-100" v-model="fd.operation_mode" filterable placeholder="请选择船舶类型">
                <el-option v-for="(item, index) in operation_mode_list" :key="index" :label="item.value"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="船舶MMSI" prop="mmsi">
              <el-input v-model="fd.mmsi"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="船级" prop="classification">
              <el-input v-model="fd.classification"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="船旗" prop="flag">
              <el-input v-model="fd.flag"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="原船籍港" prop="origin_reg_port">
              <el-input v-model="fd.origin_reg_port"></el-input>
            </el-form-item>
          </el-col>
          <!--<el-col :span="8">
            <el-form-item label="船舶登记号" prop="reg_num">
              <el-input v-model="fd.reg_num"></el-input>
            </el-form-item>
          </el-col>-->
        </el-row>
        <el-row>
          <!--<el-col :span="8">
            <el-form-item label="证书有效期" prop="cert_expire_date">
              <el-date-picker v-model="fd.cert_expire_date"
                              type="date" value-format="yyyy-MM-dd"
                              placeholder="请选择证书有效期" class="w-100"></el-date-picker>
            </el-form-item>
          </el-col>-->
        </el-row>
        <el-row>
          <el-col :span="24" class="border-top mt-2 pt-3">
            <el-form-item>
              <el-button size="small" @click="cancelData">取消</el-button>
              <template v-if="$perm(['ship.add_ship'])">
                <el-button size="small" type="primary" @click="createData(1)">保存</el-button>
                <el-button size="small" type="primary" @click="createData(2)">保存并新增</el-button>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  import {createShip} from "@/api/ship"
  import {searchList as fetchShipList, fetchShip} from '@/api/ship';
  import ship from '@/mixins/ship'
  import loading from '@/mixins/loading'

  export default {
    name: "create",
    mixins: [ship, loading],
    data() {
      return {
        ship_list: []
      }
    },
    methods: {
      querySearchShip() {
        this.ship_list = [];
        fetchShipList()
          .then(res => {
            this.ship_list = Object.assign([], res)
          })
          .catch(error => {
            this.$error_message(error)
          })
      },
      handleSelectShip(sid) {
        fetchShip(sid)
        .then(res => {
          for (var k in this.fd) {
            if (k == 'former_name') {
              continue
            }
            this.fd[k] = res[k]
          }
          this.fd['former_name'] = res['name']
          this.fd['origin_reg_port'] = res['reg_port']
        })
        .catch(error => {
          this.$error_message(error);
        })
      },
      createData(type) {
        this.$refs["dataForm"].validate(valid => {
          if (valid) {
            this.saving = true
            this.savingText = "正在保存船舶数据，请稍等..."
            createShip(this.fd)
              .then(res => {
                this.shipid = res.id
                this.saving = false
                this.$message.success("保存船舶信息成功")
                this.$nextTick(() => {
                  this.$refs.dataForm.resetFields()
                  this.resetFD();
                  if (type == 1) {
                    this.$router.push({name: "shipUpdate", query: {id: this.shipid}})
                  }
                });
              })
              .catch(error => {
                this.saving = false
                this.$error_message(error);
              });
          }
        });
      },
    },
    created() {
      this.loadData()
      this.querySearchShip()
    }
  }
</script>
